import type { HelpFile } from '../../types/help'
import { TimeSwitchTestIds } from '../../../testids/TimeSwitchTestIds'

export const timeSwitchHelp: HelpFile = {
  docPage: '/docs/admin/time-travel',
  texts: {
    [TimeSwitchTestIds.btnTimeSwitch]: null,
    [TimeSwitchTestIds.btnSetTime]: 'Set the simulated current time used for time-bound checks like access validity windows.',
    [TimeSwitchTestIds.btnResetTime]: 'Reset the simulated time back to the real current time.',
    [TimeSwitchTestIds.btnAdvance1Day]: 'Advance the simulated time by one day to test next-day behavior.',
    [TimeSwitchTestIds.btnAdvance7Days]: 'Advance the simulated time by seven days to test next-week behavior.',
    [TimeSwitchTestIds.btnAdvance30Days]: 'Advance the simulated time by thirty days to test month-end behavior.',
    [TimeSwitchTestIds.timeSwitchInput]: 'Date and time the simulated clock should jump to when Set is pressed.',
  },
}
